// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__KYWuc","change_job_status":"Modal_change_job_status__r+oxe","ModalOverlay":"Modal_ModalOverlay__ZX7-H"};